<template>
  <g>
    <path fill="#90caf9" d="M39,26c0,8.8-7.2,16-16,16S7,34.8,7,26s7.2-16,16-16S39,17.2,39,26z"
          :style="{ fill : $attrs.bgColor }"/>
    <path fill="#1e88e5"
          d="M23,43c-5,0-9-7.5-9-17c0-9.5,4-17,9-17s9,7.5,9,17C32,35.5,28,43,23,43z M23,11c-3.8,0-7,6.9-7,15 s3.2,15,7,15c3.8,0,7-6.9,7-15S26.8,11,23,11z"/>
    <path fill="#1e88e5"
          d="M36.3 19H9.7c-.6 0-1-.4-1-1s.4-1 1-1h26.7c.6 0 1 .4 1 1S36.9 19 36.3 19zM36.3 35H9.7c-.6 0-1-.4-1-1s.4-1 1-1h26.7c.6 0 1 .4 1 1S36.9 35 36.3 35zM7 25H39V27H7z"/>
    <path fill="#1e88e5" d="M22 10H24V42H22z"/>
    <path fill="#1e88e5"
          d="M37.8,20.1c-1.5,2.3-2.8,4.1-2.8,4.1s-7-9.2-7-13.1c0-0.1,0-0.2,0-0.2c-1.3-0.4-2.6-0.7-4-0.8 c0,0.3-0.1,0.7-0.1,1c0,4.7,5.5,12.4,7.8,15.5l3.2,4.2l3.2-4.2c0.2-0.3,0.5-0.7,0.8-1.1C38.9,23.6,38.5,21.7,37.8,20.1z"/>
    <path fill="#1e88e5"
          d="M35,14C35,14,35,14,35,14c-1.5,0-2.7-1-3-2.3C29.4,10,26.3,9,23,9C13.6,9,6,16.6,6,26 c0,9.4,7.6,17,17,17s17-7.6,17-17C40,21.3,38.1,17.1,35,14z M23,41c-8.3,0-15-6.7-15-15s6.7-15,15-15s15,6.7,15,15S31.3,41,23,41z"/>
    <path fill="#ff3d00"
          d="M35,4.1c-3.9,0-7,3.1-7,7c0,3.9,7,13,7,13s7-9.1,7-13S38.9,4.1,35,4.1z M35,14c-1.7,0-3-1.3-3-3 s1.3-3,3-3s3,1.3,3,3S36.7,14,35,14z"/>
  </g>
</template>

<script>
export default {
  name: "svgLocation"
}
</script>

<style scoped>

</style>